import React from "react";

import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

import {
  Routes,
  HashRouter,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";
import { App } from "./App";

import { APIProvider, APIContext, useAPI } from "./Api";
import { CartProvider } from "./Cart";

import { createRoot } from "react-dom/client";
import { LibraryProvider } from "./Library";

console.log("RELEASE", process.env.RELEASE);
// (function (d, w, c) {
// 	w.ChatraID = process.env.CHATRAID;
// 	var s = d.createElement('script');
// 	w[c] = w[c] || function () {
// 		(w[c].q = w[c].q || []).push(arguments);
// 	};
// 	s.async = true;
// 	s.src = 'https://call.chatra.io/chatra.js';
// 	if (d.head) d.head.appendChild(s);
// })(document, window, 'Chatra');

if (process.env.SENTRYDSN || process.env.SENTRYDSN != "FIXME")
  Sentry.init({
    dsn: process.env.SENTRYDSN,
    // integrations: [new BrowserTracing()],
    release: process.env.RELEASE,
    tracesSampleRate: 1.0,
    // integrations: [
    // 	new BrowserTracing({
    // 		routingInstrumentation: Sentry.reactRouterV6Instrumentation(
    // 			React.useEffect,
    // 			useLocation,
    // 			useNavigationType,
    // 			createRoutesFromChildren,
    // 			matchRoutes,
    // 		),
    // 	}),
    // ],
  });

var container = document.getElementById("root");

if (!container) {
  container = document.createElement("div");
  container.id = "root";

  document.querySelector("body").appendChild(container);
}

const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  //<React.StrictMode>
  <HashRouter>
    <APIProvider
      onAuth={(r) => {
        let d = { ...r, jwt: null };

        // window.Chatra('setIntegrationData',d);
      }}
    >
      <LibraryProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </LibraryProvider>
    </APIProvider>
  </HashRouter>

  //</React.StrictMode>
);
